const CONFIG = {
  embedded: {
    label: "Facebook",
    className: "bg-blue-50 text-blue-800 border-blue-200",
  },
  manual: {
    label: "Manual",
    className: "bg-violet-50 text-violet-800 border-violet-200",
  },
};

const ConnectionTypeBadge = ({ connectionType }) => {
  const type = connectionType === "manual" ? "manual" : "embedded";
  const cfg = CONFIG[type];

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide border ${cfg.className}`}
    >
      {type === "embedded" ? (
        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      ) : (
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      )}
      {cfg.label}
    </span>
  );
};

export default ConnectionTypeBadge;
